import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  connect() {
    if (!this.element.classList.contains("modal")) return;

    this.modal = new Modal(this.element);
    this.modal.show();
    this.handleImageLoadingInModal();
    this._closing = false;

    this.element.addEventListener('hidden.bs.modal', this._onHidden = () => {
      this._cleanup();
    });
  }

  disconnect() {
    if (this._onHidden) {
      this.element.removeEventListener('hidden.bs.modal', this._onHidden);
      this._onHidden = null;
    }
    if (this.modal) {
      try { this.modal.dispose(); } catch (_) { }
      this.modal = null;
    }
    const otherOpenModals = document.querySelectorAll('.modal.show');
    if (otherOpenModals.length === 0) {
      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');
    }
  }

  handleFrameLoad() {
    this.handleImageLoadingInModal();
  }

  handleImageLoadingInModal() {
    const images = this.element.querySelectorAll('img[data-image-rotation-target]');
    images.forEach(img => {
      if (!img.complete || img.naturalWidth === 0) {
        const loadingDiv = document.createElement('div');
        loadingDiv.className = 'text-center text-muted small';
        loadingDiv.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Loading image...';
        img.parentNode.insertBefore(loadingDiv, img);

        img.addEventListener('load', () => {
          loadingDiv.remove();
        });

        img.addEventListener('error', () => {
          loadingDiv.innerHTML = '<i class="fas fa-exclamation-triangle"></i> Image temporarily unavailable';
        });
      }
    });
  }

  close() {
    if (this._closing) return;
    this._closing = true;

    if (this.element.dataset.targetUpdate) {
      const target = document.querySelector(this.element.dataset.targetUpdate);
      const source = document.querySelector(this.element.dataset.sourceUpdate);
      if (target && source) {
        target.value = source.value;
      }
    }

    if (this.modal) {
      this.modal.hide();
      this._cleanupTimer = setTimeout(() => this._cleanup(), 500);
    } else {
      this._cleanup();
    }
  }

  _cleanup() {
    this._closing = false;

    if (this._cleanupTimer) {
      clearTimeout(this._cleanupTimer);
      this._cleanupTimer = null;
    }

    if (this.modal) {
      this.modal.dispose();
      this.modal = null;
    }

    const turboModal = document.getElementById("turbo_modal");
    if (turboModal) {
      turboModal.removeAttribute("src");
      turboModal.innerHTML = "";
    }

    if (this.element.dataset.removeModal !== "false") {
      this.element.remove();
    }
  }

  escClose(event) {
    if (event.key === "Escape") this.close();
  }
}
